import { useState, useEffect } from "react";
import { GiTrophyCup } from "react-icons/gi";
import { HiRefresh } from "react-icons/hi";
import { FaDice } from "react-icons/fa";
import { socket } from "../../api";
import { parseJWT } from "../../utils/jwtUtils";

export default function GameWinners() {
  const [activeTab, setActiveTab] = useState("winners");
  const [winners, setWinners] = useState([]);

  const token = localStorage.getItem("userInfo")
    ? JSON.parse(localStorage.getItem("userInfo"))
    : null;

  const userInfo = parseJWT(token?.token);

  useEffect(() => {
    socket.on("game-history", handleHistory);
    socket.on("user-history", handleHistory);

    socket.emit("get-game-history");

    return () => {
      socket.off("game-history");
      socket.off("user-history");
    };
  }, []);

  const handleHistory = (data) => {
    const formatted = data.map((winner) => ({
      name: maskPhone(winner.name),
      amount: winner.amount,
      game: winner.game,
      time: formatTime(winner.time),
    }));

    setWinners(formatted);
  };

  const maskPhone = (phone) => {
    if (!phone) return "Player";
    return phone.slice(0, 4) + "***";
  };

  const formatTime = (date) => {
    const diff = Math.floor((Date.now() - new Date(date)) / 3600000);
    return diff <= 1 ? "Just now" : `${diff}h ago`;
  };

  const loadWinners = () => {
    socket.emit("get-game-history");
  };

  const loadTransactions = () => {
    socket.emit("get-user-history", userInfo.phone);
  };

  return (
    <div className="w-full max-w-md mx-auto bg-[#134454] rounded-xl shadow-2xl overflow-hidden border border-[#185163]">
      {/* Header */}
      <div className="bg-gradient-to-l from-cyan-900 via-cyan-800 to-cyan-900 px-5 py-4 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <GiTrophyCup className="text-yellow-400 text-lg animate-pulse" />
          <h2 className="font-semibold text-white text-lg font-serif">
            Transactions & Winners
          </h2>
        </div>

        <HiRefresh
          onClick={activeTab === "winners" ? loadWinners : loadTransactions}
          className="text-white text-xl cursor-pointer hover:rotate-180 transition duration-500"
        />
      </div>

      {/* Tabs */}
      <div className="flex border-b border-[#185163] bg-[#0c3745]">
        <button
          onClick={() => {
            setActiveTab("winners");
            loadWinners();
          }}
          className={`flex-1 py-3 text-sm font-semibold transition ${
            activeTab === "winners"
              ? "text-cyan-400 border-b-2 border-cyan-400"
              : "text-gray-400"
          }`}
        >
          Winners
        </button>

        <button
          onClick={() => {
            setActiveTab("transactions");
            loadTransactions();
          }}
          className={`flex-1 py-3 text-sm font-semibold transition ${
            activeTab === "transactions"
              ? "text-cyan-400 border-b-2 border-cyan-400"
              : "text-gray-400"
          }`}
        >
          My Transactions
        </button>
      </div>

      {/* Content */}
      <div className="p-4 space-y-4 bg-[#113b4a]">
        {winners.length === 0 ? (
          <div className="text-center text-gray-400 py-6">
            No transactions yet.
          </div>
        ) : (
          winners.map((winner, index) => (
            <div
              key={index}
              className="bg-[#0c3745] rounded-lg p-4 border border-[#185163] flex justify-between items-center shadow-md hover:scale-[1.02] transition"
            >
              <div>
                <p className="text-white font-semibold">{winner.name}</p>

                <div className="flex items-center gap-2 text-gray-400 text-sm mt-1">
                  <FaDice className="text-green-400 text-xs" />
                  <span>Game: {winner.game.slice(0, 13)}</span>
                </div>
              </div>

              <div className="text-right">
                <p className="text-green-400 font-bold text-lg">
                  +{winner.amount} ETB
                </p>
                <p className="text-gray-400 text-xs mt-1">{winner.time}</p>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
